import type { CSSProperties } from 'react';
import { CSS_PROPS, OTHER_PROPS } from 'common/constants/component-props';

export const BOX_TYPE = {
	FRAME: 'FRAME' as 'FRAME',
	STACK: 'STACK' as 'STACK',
	GRID: 'GRID' as 'GRID',
} as const;

export type BoxType = ValuesType<typeof BOX_TYPE>;

export const defaultProps = {
	[OTHER_PROPS.box.boxType]: BOX_TYPE.FRAME,
	[CSS_PROPS.layout.flexWrap]: 'nowrap' as CSSProperties['flexWrap'],
	[CSS_PROPS.layout.alignItems]: 'stretch' as CSSProperties['alignItems'],
	[CSS_PROPS.layout.flexDirection]: 'column' as CSSProperties['flexDirection'],
	[CSS_PROPS.layout.justifyContent]: 'start' as CSSProperties['justifyContent'],
};
